import DemoSidebar from "@/components/demo/DemoSidebar";
import "@/styles/metallic-theme.css";

export default function DemoLayout({ children, alertCount = 0 }) {
  return (
    <div className="metallic-page" data-testid="demo-layout">
      <DemoSidebar alertCount={alertCount} />
      <main style={{
        marginLeft: 260,
        minHeight: "100vh",
        padding: "24px 32px",
        background: "var(--surface-page)",
      }}>
        {children}
      </main>
    </div>
  );
}
